import { render } from "./EventList.vue?vue&type=template&id=f0dc5baa&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=f0dc5baa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f0dc5baa"

export default script